// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  GET_FLIGHT: `${environment.apiUrl}/flight/:id`,
  GET_AVAILABLE_REQUESTS: `${environment.apiUrl}/flight/:id/order/list`,
  GET_FLIGHT_SALES: `${environment.apiUrl}/flight/:id/sale/list`,
  GET_ONLINE_STORES: `${environment.apiUrl}/meta/store/10`,
  GET_TRAVELER_REWARD: `${environment.apiUrl}/traveler-reward/progress/:flightId`,
});

export const getFlightApi = getCreator(fetch, endpoints.GET_FLIGHT);
export const getAvailableRequestsApi = getCreator(fetch, endpoints.GET_AVAILABLE_REQUESTS);
export const getFlightSalesApi = getCreator(fetch, endpoints.GET_FLIGHT_SALES);
export const getOnlineStores = getCreator(fetch, endpoints.GET_ONLINE_STORES);
export const getTravelerRewardApi = getCreator(fetch, endpoints.GET_TRAVELER_REWARD);



// WEBPACK FOOTER //
// ./src/modules/flight/api.js